



































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import CustomButton from "@/components/Globals/CustomButton.vue";
import ShareYourDesignForm from '@/components/molecule.modal.shareYourDesignform.vue';
import ConfirmationShareYourDesign from '@/components/molecule.modal.confirmationShareYourDesign.vue';

@Component({
  components: {
    CustomContainer,
    CustomModal,
    CustomButton,
    ShareYourDesignForm,
    ConfirmationShareYourDesign,
    ModalHeader,
    }
})
export default class ShareYourDesign extends Vue {
  disableSendButton: boolean = true;
  hideConfirmationModal: boolean = true;

  @Prop({default: false})
  enableCheck!: Boolean;

  closeModal(){
    this.$eventBus.$emit("closeShareYourDesignModal");
  }

  blockCtaPrimaryButton(block: boolean): void {
    this.disableSendButton = block;
  }

  showHideConfirmationModal(isEnable: boolean): void {
    this.hideConfirmationModal = isEnable;
  }

  beforeOpen(){}
  beforeClose(){}
}
